export const leadFormStyles = fontColor => ({
    title: {
        textAlign: 'center',
        paddingBottom: 20
    },
    popupIndicator: {
        color: fontColor
    },
    outlinedInput: {
        '&.MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: fontColor
            },
            '&:hover fieldset': {
                borderColor: fontColor
            },
            '&.Mui-focused fieldset': {
                borderColor: fontColor
            }
        }
    },
    inputLabel: {
        color: fontColor,
        '&.Mui-focused': {
            color: fontColor
        }
    },
    inputText: {
        color: fontColor
    },
    datePickerInput: {
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: fontColor
            },
            '&:hover fieldset': {
                borderColor: fontColor
            },
            '&.Mui-focused fieldset': {
                borderColor: fontColor
            }
        },
        '& .MuiInputBase-input': {
            color: fontColor
        },
        '& .MuiInputLabel-root': {
            color: fontColor
        },
        '& .MuiInputLabel-root.Mui-focused': {
            color: fontColor
        },
        '& .MuiIconButton-root': {
            color: fontColor
        }
    },
    checkboxRoot: {
        color: fontColor,
        '&.Mui-checked': {
            color: fontColor
        },
        paddingTop: 2,
        paddingBottom: 2
    }
});
